import { combineReducers } from "react-reducer-store"

import appReducer from "../../modules/app/reducer"

const rootReducer = combineReducers({
  app: appReducer,
})

export default rootReducer
